import { useState } from 'react'
import QRCode from 'react-qr-code'

function QRCodeGenerator({ property }) {
  const [showQR, setShowQR] = useState(false)

  const propertyUrl = `${window.location.origin}/property/${property.id}`
  const propertyData = {
    title: property.title,
    price: `${property.currency} ${property.price}`,
    location: `${property.city}, ${property.country}`,
    url: propertyUrl
  }

  const downloadQR = () => {
    const svg = document.getElementById(`qr-${property.id}`)
    const svgData = new XMLSerializer().serializeToString(svg)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const img = new Image()
    img.onload = () => {
      canvas.width = img.width
      canvas.height = img.height
      ctx.drawImage(img, 0, 0)
      const pngFile = canvas.toDataURL('image/png')
      const downloadLink = document.createElement('a')
      downloadLink.download = `property_${property.id}_qr.png`
      downloadLink.href = pngFile
      downloadLink.click()
    }
    img.src = 'data:image/svg+xml;base64,' + btoa(svgData)
  }

  return (
    <>
      <button
        onClick={() => setShowQR(true)}
        style={qrBtn}
        title="Generate QR Code"
      >
        📱 QR Code
      </button>

      {showQR && (
        <div style={modalOverlay} onClick={() => setShowQR(false)}>
          <div style={qrModal} onClick={(e) => e.stopPropagation()}>
            <h3>🏠 {property.title}</h3>
            <div style={qrContainer}>
              <QRCode
                id={`qr-${property.id}`}
                value={JSON.stringify(propertyData)}
                size={200}
                bgColor="#ffffff"
                fgColor="#1e3a5f"
                level="H"
              />
            </div>
            <p style={qrUrl}>{propertyUrl}</p>
            <div style={qrActions}>
              <button onClick={downloadQR} style={downloadBtn}>📥 Download QR Code</button>
              <button onClick={() => window.print()} style={printBtn}>🖨️ Print</button>
            </div>
            <button onClick={() => setShowQR(false)} style={closeBtn}>Close</button>
          </div>
        </div>
      )}
    </>
  )
}

const qrBtn = {
  background: '#6b7280',
  color: '#fff',
  border: 'none',
  padding: '8px 16px',
  borderRadius: 8,
  cursor: 'pointer',
  marginRight: 8,
  fontSize: 13
}

const qrModal = {
  background: '#fff',
  padding: 25,
  borderRadius: 20,
  width: '90%',
  maxWidth: 350,
  textAlign: 'center'
}

const qrContainer = {
  display: 'flex',
  justifyContent: 'center',
  margin: '20px 0',
  padding: 20,
  background: '#fff'
}

const qrUrl = {
  fontSize: 11,
  color: '#666',
  wordBreak: 'break-all',
  background: '#f0f4f8',
  padding: 8,
  borderRadius: 8,
  margin: '10px 0'
}

const qrActions = {
  display: 'flex',
  gap: 10,
  margin: '15px 0'
}

const downloadBtn = {
  background: '#059669',
  color: '#fff',
  border: 'none',
  padding: '8px 12px',
  borderRadius: 8,
  cursor: 'pointer',
  flex: 1
}

const printBtn = {
  background: '#2c7da0',
  color: '#fff',
  border: 'none',
  padding: '8px 12px',
  borderRadius: 8,
  cursor: 'pointer',
  flex: 1
}

const modalOverlay = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0,0,0,0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000
}

const closeBtn = {
  background: '#dc2626',
  color: '#fff',
  border: 'none',
  padding: '8px 16px',
  borderRadius: 8,
  cursor: 'pointer',
  width: '100%',
  marginTop: 10
}

export default QRCodeGenerator